<div *ngIf="reportType == 'VeryBriefly-Officer'">
  <div class="container" id="print-section" style="padding: 20px; background: white; border-radius: 8px;">
    <table class="table table-bordered" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 14px;">
      
        <tr style="background-color: #f0f0f0; font-weight: 600; text-align: center;">
          <th colspan="1" style="border: 1px solid #999; padding: 8px;width: 0%;">Vivek Saptahik</th>
          <th colspan="1" style="border: 1px solid #999; padding: 8px;width: 0%;">Issue Seller Payment <br>Receipt Ledger-VB</th>
          <th colspan="1" style="border: 1px solid #999; padding: 8px;width: 0%;">{{startDate | date: 'dd-MM-yyyy'}}<br> to {{endDate | date: 'dd-MM-yyyy'}}</th>
        </tr>
        <tr style="background-color: #fafafa; font-weight: 600; text-align: center;">
          <th style="border: 1px solid #999; padding: 8px;width: 0%;">Representative <br>Name</th>
          <th style="border: 1px solid #999; padding: 8px;width: 0%;">Office <br>Representative</th>
          <th style="border: 1px solid #999; padding: 8px;width: 0%;">Received Amount</th>
        </tr>
      

      <tbody *ngFor="let data of advtFormBeans; let i = index" style="border-bottom: 2px solid #ccc;">
        <!-- Office Rep Header -->
        <tr style="background-color: #e9ecef; font-weight: 700;">
          <td colspan="1" style="border: 1px solid #999; padding: 8px;width: 0%;">Office Representative</td>
          <td colspan="2" style="border: 1px solid #999; padding: 8px;width: 0%;">{{data.office_rep}}</td>
        </tr>

        <!-- List of reps under the office rep -->
        <tr *ngFor="let data1 of data.rep_data">
          <td style="border: 1px solid #999; padding: 6px 8px;">{{data1.rep_name}}</td>
          <td style="border: 1px solid #999; padding: 6px 8px;">{{data.office_rep}}</td>
          <td style="border: 1px solid #999; padding: 6px 8px; text-align: right;">{{data1.rcv_amt | number:'1.2-2'}}</td>
        </tr>

        <!-- Total per Office Rep -->
        <tr style="font-weight: 700; background-color: #f0f8ff;">
          <td colspan="2" style="border: 1px solid #999; padding: 8px; text-align: right;">Total for {{data.office_rep}}:</td>
          <td style="border: 1px solid #999; padding: 8px; text-align: right;">{{data.total | number:'1.2-2'}}</td>
        </tr>
      </tbody>

     
        <tr style="background-color: lightcyan; font-weight: bold;">
          <td colspan="2" style="border: 1px solid #999; padding: 10px; text-align: right;">Grand Total:</td>
          <td style="border: 1px solid #999; padding: 10px; text-align: right;">{{advtVBTotal | number:'1.2-2'}}</td>
        </tr>
    
    </table>
  </div>

  <div class="noPrint" style="margin-left: 80%; margin-top: 15px; margin-bottom: 20px; display: flex; gap: 10px;">
    <button
      style="padding: 10px 20px; font-weight: 600;"
      (click)="exportExcel('Payment_Receipt_Reg_Very_Brifly_Report')"
      mat-raised-button
      color="primary"
    >
      Export
    </button>

    <button
      style="padding: 10px 20px; font-weight: 600;"
      mat-raised-button
      color="primary"
      printSectionId="print-section"
      ngxPrint
      [useExistingCss]="true"
    >
      Print
    </button>

    <button
      style="padding: 10px 20px; font-weight: 600;"
      mat-button
      mat-dialog-close
    >
      Close
    </button>
  </div>
</div>
